import React from 'react';

const StickyFooter = ({ label, disabled, onClick }) => {
  return (
    <div
      className="t-fixed t-bottom-0 t-left-0 t-right-0 t-bg-surface/[.96] t-backdrop-blur-[10px] t-border-t t-border-g200 t-py-3.5 t-px-[18px] t-flex t-justify-center t-z-[100]"
      style={{ paddingBottom: 'max(14px, env(safe-area-inset-bottom))' }}
    >
      <button
        type="button"
        className="t-w-full t-max-w-[520px] t-py-[15px] t-px-6 t-rounded-xl t-bg-navy t-text-surface t-font-sans t-text-[15px] t-font-semibold t-border-0 t-cursor-pointer t-outline-none hover:t-bg-[#0d2d37] disabled:t-opacity-30 disabled:t-cursor-not-allowed"
        disabled={disabled}
        onClick={onClick}
      >
        {label}
      </button>
    </div>
  );
};

export default React.memo(StickyFooter);
